import { tokens } from "shared/components/Spor";
import { appPalette } from "shared/theme/colors/appPalette";
import { mapValues } from "shared/utils/arrayUtils";
// After SporV2 we need to retrieve the colors directly from palette
const { palette } = tokens.default.color;
const alias = mapValues(tokens.default.color.alias, (value) => {
  const [_, color, strength] = value.split(".");
  return (palette as any)[color][strength];
});

const colors = {
  ...appPalette,
  ...alias,
  ...palette,
};

// Spor 13.7's design-token typings are out of sync with the runtime tokens:
// palette is typed with extra color-scale objects that don't actually exist at runtime.
export default colors as unknown as {
  [K in keyof typeof colors]: string;
};
